import React from "react";

export const passwordError = (password, confirmation) => {
  const length = Array.from(password).length;
  if (length < 8 || length > 25 || !password.trim()) return "Use a password with 8 to 25 characters.";
  if (password !== confirmation) return "Passwords do not match.";
  return "";
};
export const authInput = "mt-1 w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-slate-900 outline-none transition focus:border-[#2563EB] focus:ring-2 focus:ring-[#2563EB]/20";
export const authButton = "rounded-lg bg-[#2563EB] px-4 py-2 font-semibold text-white disabled:opacity-50";
export default function PasswordFields({ password, confirmation, onPassword, onConfirmation }) {
  return <>
    <label className="block text-sm font-semibold">New password
      <input className={authInput} type="password" autoComplete="new-password" required minLength={8} maxLength={50}
        value={password} onChange={(event) => onPassword(event.target.value)} />
    </label>
    <p className="text-xs text-slate-600">Use 8 to 25 characters. Choose a unique password.</p>
    <label className="block text-sm font-semibold">Confirm new password
      <input className={authInput} type="password" autoComplete="new-password" required minLength={8} maxLength={50}
        value={confirmation} onChange={(event) => onConfirmation(event.target.value)} />
    </label>
  </>;
}
